import {
    SET_PERMISSIONS,
    SET_USER_PERMISSIONS,
    PERMISSION_ERROR,
    SET_USER_ROLE,
    LOADING_USER_PERMISSION,
    LOADING_COMPONENT_PERMISSION
} from "../../types";

const initialState = {
    properties: {},
    userPermissions: [],
    userRole: 0,
    loadingUserPermission: true,
    loadingComponentPermission: true,
    settings: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PERMISSIONS: {
            const { component, data } = payload;
            return {
                ...state,
                [component]: data
            };
        }
        case SET_USER_PERMISSIONS:
            return {
                ...state,
                userPermissions: payload
            };
        case SET_USER_ROLE:
            return {
                ...state,
                userRole: payload
            };
        case LOADING_USER_PERMISSION: {
            return {
                ...state,
                loadingUserPermission: payload
            };
        }
        case LOADING_COMPONENT_PERMISSION: {
            return {
                ...state,
                loadingComponentPermission: payload
            };
        }
        case PERMISSION_ERROR:
            return {
                ...state,
                properties: {},
                isCheckingPermission: true
            };
        default:
            return state;
    }
}